<div class="header">
  <div class="logo logo-dark">
    <a href="">
      <img class="logo-full" src="assets/images/logo/logohtnm.jpg" alt="Logo">
      <img class="logo-fold" src="assets/images/logo/logohtnm.jpg" alt="Logo">
    </a>
  </div>
  <div class="logo logo-white">
    <a href="">
      <img class src="assets/images/logo/logohtnm.jpg" alt="Logo">
      <img class="logo-fold" src="assets/images/logo/logohtnm.jpg" alt="Logo">
    </a>
  </div>
  <div class="nav-wrap">
    <ul class="nav-left">
      <li class="desktop-toggle">
        <a (click)="toggleFold()">
          <i nz-icon [nzType]="isFolded? 'menu-unfold':'menu-fold'" theme="outline"></i>
        </a>
      </li>
      <li class="mobile-toggle">
        <a (click)="toggleExpand()">
          <i nz-icon [nzType]="isExpand? 'menu-fold': 'menu-unfold'" theme="outline"></i>
        </a>
      </li>
      <!--      <li>-->
      <!--        <a (click)="searchToggle()">-->
      <!--          <i nz-icon nzType="search" theme="outline"></i>-->
      <!--        </a>-->
      <!--        <nz-drawer [nzWidth]="380" nzTitle="Search" [nzVisible]="searchVisible" nzPlacement="left"-->
      <!--                   (nzOnClose)="searchToggle()">-->
      <!--          <app-search></app-search>-->
      <!--        </nz-drawer>-->
      <!--      </li>-->

    </ul>
    <ul class="nav-right">
      <li>
        <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="popNotification" [nzPlacement]="'bottomRight'"
           (click)="loadRecentNotifications()">
          <nz-badge [nzCount]="notiUnreadCount" [nzOverflowCount]="9">
            <i nz-icon nzType="bell" theme="outline" style="font-size: 18px;"></i>
          </nz-badge>
        </a>
        <nz-dropdown-menu #popNotification="nzDropdownMenu">
          <div nz-menu class="pop-notification" style="width: 320px;">
            <div class="p-v-15 p-h-25 border-bottom d-flex justify-content-between align-items-center">
              <p class="text-dark font-weight-semibold m-b-0">
                <i nz-icon nzType="bell" theme="outline"></i>
                <span class="m-l-10">Thông báo</span>
              </p>
            </div>
            <perfect-scrollbar class="overflow-y-auto" style="max-height: 300px">
              <nz-empty *ngIf="notificationList.length === 0" nzNotFoundContent="Không có thông báo"></nz-empty>
              <nz-list [nzDataSource]="notificationList" [nzRenderItem]="notiItem" [nzItemLayout]="'horizontal'">
                <ng-template #notiItem let-item>
                  <nz-list-item>
                    <div class="p-h-15 p-v-5 w-100 pointer" (click)="onNotiClick(item)">
                      <p class="m-b-0 text-dark font-weight-semibold">{{ item.title }}</p>
                      <p class="m-b-0 text-gray">{{ item.message }}</p>
                      <small class="opacity-07">{{ item.createdDate | date: 'dd/MM/yyyy HH:mm' }}</small>
                    </div>
                  </nz-list-item>
                </ng-template>
              </nz-list>
            </perfect-scrollbar>
          </div>
        </nz-dropdown-menu>
      </li>
      <li>
        <span class="p-h-10 pointer" nz-dropdown [nzDropdownMenu]="profile" [nzTrigger]="'click'"
              [nzPlacement]="'bottomRight'">
            <nz-avatar nzIcon="user" style="background-color:#447651;"></nz-avatar>
        </span>
        <nz-dropdown-menu #profile="nzDropdownMenu">
          <ul nz-menu class="p-b-10 p-t-10">
            <li class="p-h-20 p-b-10 border-bottom">
              <div class="d-flex m-r-50">
                <div class="m-l-10">
                  <p class="m-b-0 text-dark font-weight-semibold">{{ user.name }}</p>
                  <p class="m-b-0 opacity-07">{{ user.userName }}</p>
                  <p class="m-b-0">{{ RoleTypes | where: ['value', user.userRole] | pluck: 'name'}}</p>
                  <small class="m-b-0 opacity-07">Đăng nhập {{ user.lastLogin | timeAgo }}</small>
                </div>
              </div>
            </li>

            <li nz-menu-item (click)="redirectProfile()">
              <a class="d-flex align-items-center justify-content-between">
                <div>
                  <i-tabler name="user" class="tb-icon tb-icon-m center m-r-5"></i-tabler>
                  <span class="m-l-10">Cập nhật thông tin</span>
                </div>
                <i class="font-size-10" nz-icon nzType="right" theme="outline"></i>
              </a>
            </li>

            <li nz-menu-item (click)="openNewTab()">
              <a class="d-flex align-items-center justify-content-between">
                <div>
                  <i-tabler name="external-link" class="tb-icon tb-icon-m center m-r-5"></i-tabler>
                  <span class="m-l-10">Đến trang chủ</span>
                </div>
                <i class="font-size-10" nz-icon nzType="right" theme="outline"></i>
              </a>
            </li>
            <li nz-menu-item (click)="signOut()">
              <a class="d-flex align-items-center justify-content-between">
                <div>
                  <i-tabler name="logout" class="tb-icon tb-icon-m center m-r-5"></i-tabler>
                  <span class="m-l-10">Logout</span>
                </div>
                <i class="font-size-10" nz-icon nzType="right" theme="outline"></i>
              </a>
            </li>
          </ul>
        </nz-dropdown-menu>
      </li>
    </ul>
  </div>
</div>
